export default "__VITE_ASSET__w59x_AQu__"